export class ApiError extends Error {
    status;
    constructor(message, status) {
        super(message);
        this.status = status;
        this.name = "ApiError";
    }
}
// A 401 means the session is gone (expired, revoked elsewhere) — every dashboard/game call
// site would otherwise just render an empty state with no explanation. Redirect once, here,
// instead of every caller needing its own check.
async function throwApiError(res) {
    const body = (await res.json().catch(() => ({})));
    const message = body.error ?? body.message ?? `HTTP ${res.status}`;
    if (res.status === 401)
        window.location.replace("/");
    throw new ApiError(message, res.status);
}
export async function apiGet(path) {
    const res = await fetch(path, { credentials: "include" });
    if (!res.ok)
        return throwApiError(res);
    return res.json();
}
export async function apiPost(path, body) {
    const init = {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
    };
    if (body !== undefined)
        init.body = JSON.stringify(body);
    const res = await fetch(path, init);
    if (!res.ok)
        return throwApiError(res);
    return res.json();
}
export async function apiPatch(path, body) {
    const res = await fetch(path, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    if (!res.ok)
        return throwApiError(res);
    return res.json();
}
export async function apiDelete(path) {
    const res = await fetch(path, { method: "DELETE", credentials: "include" });
    if (!res.ok)
        await throwApiError(res);
}
